export default __webpack_public_path__ + "static/media/arrowRight.ac120bca.svg";